import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxSelectBoxModule, DxValidatorModule} from "devextreme-angular";

@Component({
    selector: 'app-asset-attachment-selector',
    standalone: true,
    imports: [
        CommonModule,
        DxSelectBoxModule,
        DxValidatorModule
    ],
    templateUrl: './asset-attachment-selector.component.html',
    styles: []
})
export class AssetAttachmentSelectorComponent {
    @Input({required: true}) label!: string;
    @Input({required: true}) dataSource: any;
    @Input() value: string | null | undefined;
    @Output() valueChange = new EventEmitter<string | null | undefined>();
    @Input() required = true;

    onValueChanged(e: any) {
        this.value = e.value;
        this.valueChange.emit(this.value);
    }
}

